export const bugsData = [
    {
        "id": "CBIP-001",
        "appName": "Leading Digital Bank",
        "severity": "Low",
        "priority": "P3",
        "foundDate": "2026-09-10",
        "typeOfBug": "System-Level Integration Bug",
        "environment": "Production - Mobile App",
        "detail": "https://drive.google.com/file/d/1DZYCZZfs-8Sk-E92Kr1K7-lA9xWsTxmS/view?usp=sharing",
        "createdAt": "2026-09-19T15:08:21.081422+00:00"
    },
    {
        "id": "CBIP-002",
        "appName": "Major E-Commerce Platform",
        "severity": "High",
        "priority": "P2",
        "foundDate": "2026-09-20",
        "typeOfBug": "Logical Bug",
        "environment": "Production - Mobile App",
        "detail": "https://drive.google.com/file/d/1V0sqTOsVel6L2HL4lXLYX5j0RZTpy0Mh/view?usp=sharing",
        "createdAt": "2026-09-20T20:41:21.081422+00:00"
    },
    {
        "id": "CBIP-003",
        "appName": "Leading Digital Bank",
        "severity": "High",
        "priority": "P2",
        "foundDate": "2026-09-21",
        "typeOfBug": "Functional Bug",
        "environment": "Production - Mobile App",
        "detail": "https://drive.google.com/file/d/1Gvb1NQUYVi3ZQpzK6oXdSNPUgXns34wI/view?usp=sharing",
        "createdAt": "2026-09-21T15:30.081422+00:00"
    },
    {
        "id": "CBIP-004",
        "appName": "Leading Digital Bank",
        "severity": "High",
        "priority": "P2",
        "foundDate": "2026-09-21",
        "typeOfBug": "Concurrency Bug",
        "environment": "Production - Mobile App",
        "detail": "https://drive.google.com/file/d/1rzsSMy0IPi-RnFGCuVZRm9lVC6xOYOhO/view?usp=sharing",
        "createdAt": "2026-09-21T16:30.081422+00:00"
    },
];
